import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
import Button from "../button";
import clsx from "clsx";
import { Form, Formik, FormikContextType } from "formik";
import { createBookElementNoteValidationSchema } from "@app/validations";
import { FormControl } from "../form-control";
import TextArea from "../textarea";
import { createRef, useEffect, useState } from "react";
import { MAX_LENGTH_BOOK_NOTE } from "@app/constants";

type BookNoteModalPortalData = {
  initialTextNote?: string;
  title?: string;
};

function BookNoteModal({
  portalDialogRef,
  portalData,
}: PortalDialogProps<BookNoteModalPortalData>) {
  const formRef = createRef<FormikContextType<{ textNote: string }>>();

  const [textNote, setTextNode] = useState(portalData?.initialTextNote ?? "");

  const onSubmit = (values: { textNote?: string }) => {
    if (values.textNote) {
      portalDialogRef.close({ textNote: values.textNote });
    }
  };

  useEffect(() => {
    setTextNode(portalData?.initialTextNote ?? "");
  }, [portalData?.initialTextNote]);

  return (
    <Modal onCancel={portalDialogRef.close}>
      <div className="w-[380px] pb-6 px-6">
        <div className="pt-6 text-[#171A20] font-[SVN-Gilroy] text-[20px] font-bold text-center">
          {portalData?.title ?? "Ghi chú"}
        </div>
        <Formik
          initialValues={{
            textNote: portalData?.initialTextNote ?? "",
          }}
          innerRef={formRef}
          onSubmit={onSubmit}
          validationSchema={createBookElementNoteValidationSchema}
          validateOnBlur
          validateOnChange
        >
          <Form>
            <div className="mt-4">
              <FormControl name="textNote">
                <TextArea
                  placeholder="Nhập nội dung ghi chú"
                  errorClassName="font-[SVN-Gilroy] tracking-[0.024px]"
                  width={"100%"}
                  onChange={(e) => setTextNode(e.target.value)}
                  height={"140px"}
                  maxLength={100}
                />
              </FormControl>
              <p className="text-[14px] font-medium text-[#B0BAC9] text-right">
                {textNote.length}/{MAX_LENGTH_BOOK_NOTE}
              </p>
            </div>
            <Button
              type="submit"
              containerClassName="mt-[30px]"
              label={"Lưu"}
              labelClassName="font-[SVN-Gilroy] tracking-[0.024px]"
              width=""
              className={clsx(
                "font-bold px-11 !rounded-[22px] !h-[48px] !leading-[48px]",
                "bg-gradient-to-b from-[#5A82D7] to-[#4667CA]"
              )}
            />
          </Form>
        </Formik>
      </div>
    </Modal>
  );
}

export default BookNoteModal;
